<template>
  <section class="s-shop-select__item" id="analyse" data-step-content="02">

    <template v-if="wpData.analyse[0].shop_analyse_global_asset === false">

      <div v-if="selections.selected_analyse.shop_analyse_options_media_light" class="s-shop-select__media" v-bind:class="{ '--light-only' : selections.selected_analyse.shop_analyse_options_media_type === true }">
        <template v-if="selections.selected_analyse.shop_analyse_options_media_light[0].type === 'image'">
          <img class="s-shop-select__media-item" v-bind:src="selections.selected_analyse.shop_analyse_options_media_light[0].url">
        </template>
        <template v-if="selections.selected_analyse.shop_analyse_options_media_light[0].type === 'video'">
          <video class="s-shop-select__media-item" autoplay="" loop="" muted="" playsinline="" poster="" :src="selections.selected_analyse.shop_analyse_options_media_light[0].url"></video>
        </template>
      </div>

      <div v-if="selections.selected_analyse.shop_analyse_options_media_type === true" class="s-shop-select__media --dark-only">
        <template v-if="selections.selected_analyse.shop_analyse_options_media_dark[0].type === 'image'">
          <img class="s-shop-select__media-item" v-bind:src="selections.selected_analyse.shop_analyse_options_media_dark[0].url">
        </template>
        <template v-if="selections.selected_analyse.shop_analyse_options_media_dark[0].type === 'video'">
          <video class="s-shop-select__media-item" autoplay="" loop="" muted="" playsinline="" poster="" :src="selections.selected_analyse.shop_analyse_options_media_dark[0].url"></video>
        </template>
      </div>

    </template>

    <template v-if="wpData.analyse[0].shop_analyse_global_asset === true">

      <div v-if="wpData.analyse[0].shop_analyse_global_media_light" class="s-shop-select__media" v-bind:class="{ '--light-only' : wpData.analyse[0].shop_analyse_global_media_type === true }">
        <template v-if="wpData.analyse[0].shop_analyse_global_media_light[0].type === 'image'">
          <img class="s-shop-select__media-item" v-bind:src="wpData.analyse[0].shop_analyse_global_media_light[0].url">
        </template>
        <template v-if="wpData.analyse[0].shop_analyse_global_media_light[0].type === 'video'">
          <video class="s-shop-select__media-item" autoplay="" loop="" muted="" playsinline="" poster="" :src="wpData.analyse[0].shop_analyse_global_media_light[0].url"></video>
        </template>
      </div>

      <div v-if="wpData.analyse[0].shop_analyse_global_media_type === true" class="s-shop-select__media --dark-only">
        <template v-if="wpData.analyse[0].shop_analyse_global_media_dark[0].type === 'image'">
          <img class="s-shop-select__media-item" v-bind:src="wpData.analyse[0].shop_analyse_global_media_dark[0].url">
        </template>
        <template v-if="wpData.analyse[0].shop_analyse_global_media_dark[0].type === 'video'">
          <video class="s-shop-select__media-item" autoplay="" loop="" muted="" playsinline="" poster="" :src="wpData.analyse[0].shop_analyse_global_media_dark[0].url"></video>
        </template>
      </div>

    </template>

    <div class="s-shop-options">
      <div class="s-kicker" v-if="wpData.analyse[0].shop_analyse_kicker">{{ wpData.analyse[0].shop_analyse_kicker }}</div>
      <div v-if="wpData.analyse[0].shop_analyse_title" class="s-heading s-heading--3">
        <span class="s-heading__text">{{wpData.analyse[0].shop_analyse_title}}</span>
      </div>
      <p v-if="wpData.analyse[0].shop_analyse_copy" class="s-copy">{{wpData.analyse[0].shop_analyse_copy}}</p>
      <div v-for="(item,index) in wpData.analyse[0].shop_analyse_options" class="s-shop-option" :class="{'--is-selected': selections.selected_analyse === item}" @click="onChangeAnalyse(item)" :key="index">
        <header class="s-shop-option__header">
          <div class="s-shop-option__name">{{ item.shop_analyse_options_title }}</div>
          <div v-if="parseFloat(item.shop_analyse_options_price) > 0" class="s-shop-option__price">
            <span class="s-shop-option__price-tag">+ {{ optionPrice(parseFloat(item.shop_analyse_options_price)) | toCurrency }}</span>
            <span class="s-shop-option__price-footnote">{{ priceFootnote }}</span>
          </div>
        </header>
        <p v-if="item.shop_analyse_options_copy" class="s-copy s-copy--s s-shop-option__description">{{item.shop_analyse_options_copy}}</p>
        <ul v-if="item.shop_analyse_options_features" class="s-list s-list--check s-list--s s-list--half-tablet s-shop-option__description">
          <li v-for="item in item.shop_analyse_options_features" class="s-list__item">{{item.shop_analyse_options_features_item}}</li>
        </ul>
        <p v-if="item.shop_analyse_options_link" class="s-copy s-copy--s">
          <a v-bind:href="item.shop_analyse_options_link.url" class="s-link" v-bind:target="item.shop_analyse_options_link.target">{{ item.shop_analyse_options_link.title }}</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    priceFootnote() {
      return this.$store.state.values.payment_type_name;
    },
    wpData() {
      return this.$store.getters.wpdata[wpGlobalData.language];
    },
    selections() {
      return this.$store.state.selections;
    },
  },
  data() {
    return {
      wpGlobalData
    };
  },
  methods: {
    onChangeAnalyse(item) {
      this.$store.state.values.price_analyse = parseFloat(item.shop_analyse_options_price);
      this.$store.commit('setAnalyseOption', item)
    },
    optionPrice(price) {
      let calcValues = this.$store.state.values;
      let finalPrice = ((price * (1 - (calcValues.term_discount / 100))) * (1 - (calcValues.payment_discount / 100)));
      if(calcValues.payment_type === 'one-off'){
        return finalPrice * calcValues.term_month;
      }else if(calcValues.payment_type === 'yearly'){
        return finalPrice * 12;
      }else{
        return finalPrice;
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StepAnalyse.vue